import { Component, OnInit, Input, Output, EventEmitter, SimpleChange, OnDestroy, OnChanges } from '@angular/core';
import { UsuariosService } from 'app/_services/usuarios.service';


@Component({
  selector: 'formulariousuarioroles',
  templateUrl: './formulariousuarioroles.component.html',
  styleUrls: ['./usuarioroles.component.css']
})

export class FormulariousuariorolesComponent implements OnInit, OnChanges, OnDestroy {

  role : {descripcion:string};
  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';


  constructor(private usuariosService:UsuariosService) { }

  @Input() _idRole: any;

  @Output() onChangeRole = new EventEmitter<boolean>();
  @Output() onCloseRole = new EventEmitter<number>();



  ngOnInit() {

    if (this._idRole != 0){
      this.getRole();
    }
    else{
      this.role['descripcion'] = '';
   
    }
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }) {

    if (changes['_idRole']) {
      this._idRole = changes['_idRole'].currentValue;
    }

    if (this._idRole != 0) {
         this.getRole();
    }
    else {
      this.role['descripcion'] = '';

    }

  }

  ngOnDestroy() {
    //  this.subscription.unsubscribe();
  }

  onSubmit(a,b){

    let nuevoRole = a.form.value.descripcion ;

    if (this._idRole === 0){ // -Si es nuevo
     console.log('nuevo');
        this.usuariosService.setNuevoRoleMaestro(nuevoRole).subscribe(
          () => {
              this.onChangeRole.emit(true);
          }
        );

   }else{ // -Si estamos editando
    console.log('editar');
    this.usuariosService.setUpdateRoleMaestro(this._idRole,nuevoRole).subscribe(
      data => {this.onChangeRole.emit(true);})

   }
  }

  cerrar(destino:number){
    console.log(destino)
    this.onCloseRole.emit(destino);
  }

  getRole(){
    this.usuariosService.getRoleById(this._idRole).subscribe(
      data => {
        if (data) {
          this.role = data.json().lista[0];
          console.log(this.role)
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarioroles/formulariousuarioroles.component.ts